import React, { useState } from 'react';
import { TableRow, TableCell, TextField } from '@material-ui/core';
import { Check, Clear, Save, Edit, Cancel } from '@material-ui/icons'
import TeamRequestItemToggle from './TeamRequstItemToggle';
import gql from 'graphql-tag';
import client from '../../lib/apolloClient';
import { useMutation } from '@apollo/client';
import { result } from 'lodash';
import { Tab } from 'bootstrap';

const UPDATE_TEAM_REQUEST_ITEM = gql`
  mutation UpdateTeamRequestItem($id: ID!, $email: String!) {
    updateTeamRequestItem(id: $id, email: $email) {
      id
      email
      approved
      userDisapproved
      denyReason
      onAnotherTeam
      user {
        id
        name
        gross_production
        assets_under_management
        number_of_clients
        inventory_user {
          id
          catestrophic_plan_on_file
          continuity_builder {
            id
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

const TeamRequestItemRow = ({ item, updateTeamRequestItems }) => {
  const [edit, setEdit] = useState(false);
  const [email, setEmail] = useState(item.email);
  const [updateTeamRequestItem] = useMutation(UPDATE_TEAM_REQUEST_ITEM, { client });

  // Check for catastrophic plan from multiple sources
  const hasCatastrophicPlanOnFile = item.user?.inventory_user?.catestrophic_plan_on_file || false;
  const hasLegacyCatastrophicPlan = item.user?.inventory_user?.continuity_builder?.id ? true : false;
  const hasCatastrophicPlan = hasCatastrophicPlanOnFile || hasLegacyCatastrophicPlan;

  return <TableRow key={item.id}>
          <TableCell>
            {item.user ? <Check style={{color: 'green'}}/> :<Clear style={{color: 'red'}} />} 
          </TableCell>
          <TableCell>{edit ? <input type="text" value={email} onChange={e => {setEmail(e.target.value)}}/> : item.email}</TableCell>
          <TableCell>
            <TeamRequestItemToggle teamRequestItem={item} updateTeamRequestItems={updateTeamRequestItems} />
          </TableCell>
          <TableCell>
            {hasCatastrophicPlan ? <Check style={{color: 'green'}}/> : <Clear style={{color: 'red'}} />}
          </TableCell> 
          <TableCell>
            {item.approved === null && <span style={{color:'orange'}}>Pending Response</span>}
            {item.approved === true && <span style={{color:'green'}}>Accept</span>}
            {item.approved === false && item.userDisapproved && <span style={{color:'red'}}>Decline</span>}
            {item.approved === false && !item.userDisapproved && <span style={{color:'gray'}}>Declined by Admin</span>}
          </TableCell>
          <TableCell>
            {item.denyReason ? (
              <span title={item.denyReason} style={{cursor: 'pointer', color: '#d9534f'}}>
                {item.denyReason.length > 50 ? `${item.denyReason.substring(0, 50)}...` : item.denyReason}
              </span>
            ) : (
              <span style={{color:'gray'}}>-</span>
            )}
          </TableCell>
          <TableCell>{item.onAnotherTeam ? <span style={{color:'red'}}>ON ANOTHER TEAM</span> : <span style={{color:'green'}}>No</span>}</TableCell>
          <TableCell>
            {(!item.approved || item.userDisapproved) && <>
              {edit ? 
                <>
                  <Save 
                    style={{cursor: 'pointer', marginRight: '8px'}}
                    onClick={
                      () => {
                        updateTeamRequestItem({ variables: { id: item.id, email: email } }).then(result => {
                          setEdit(false);
                          updateTeamRequestItems(result.data.updateTeamRequestItem);
                        }
                        );
                      }
                    }
                  /> 
                  <Cancel 
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      setEdit(false);
                      setEmail(item.email);
                    }}
                  />
                </>
                :
                <Edit 
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    setEdit(true);
                    setEmail(item.email);
                  }} 
                />
              }
            </>}
          </TableCell>
        </TableRow>;
};

export default TeamRequestItemRow;
